import { useEffect } from "react";
import Modal from "react-modal";

import Toolbox from "./ui/Toolbox";
import KeyboardManager from "./ui/KeyboardManager";
import View from "./render/View";
import Data from "./app/Data";

function App() {
	useEffect(() => {
		// Register Modal app (https://github.com/reactjs/react-modal/blob/master/docs/accessibility/index.md)
		Modal.setAppElement("#root");
	}, []);
	return (
		<div style={{ display: "flex", height: "100vh", width: "100vw", overflow: "hidden" }}>
			<Data>
				<KeyboardManager />
				<div style={{ flex: "0 0 auto", width: "15rem", border: "1px solid #eeeeee" }}>
					<Toolbox />
				</div>
				<div
					style={{
						flex: "1 1 auto",
						boxSizing: "border-box",
						overflow: "hidden"
					}}
				>
					<View />
				</div>
			</Data>
		</div>
	);
}

export default App;
